import React, { useState, useEffect } from 'react';
import { List, Divider, Button, Input } from 'antd';

const ColumnVisibileManager = ({ columns, visibleColumns, setVisibleColumns, onClose }) => {
  const [localVisibleColumns, setLocalVisibleColumns] = useState(visibleColumns);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    setLocalVisibleColumns(visibleColumns);
  }, [visibleColumns]);

  const handleColumnVisibilityChange = (columnKey, checked) => {
    if (checked) {
      setLocalVisibleColumns([...localVisibleColumns, columnKey]);
    } else {
      setLocalVisibleColumns(localVisibleColumns.filter((key) => key !== columnKey));
    }
  };

  const handleApplyChanges = () => {
    setVisibleColumns(localVisibleColumns);
  };

  const handleResetToDefault = () => {
    const defaultVisibleColumns = columns.map((col) => col.key);
    setLocalVisibleColumns(defaultVisibleColumns);
    setVisibleColumns(defaultVisibleColumns);
  };

  const addColumn = (column) => {
    if (!localVisibleColumns.includes(column.key)) {
      setLocalVisibleColumns([...localVisibleColumns, column.key]);
    }
  };

  const removeColumn = (columnKey) => {
    setLocalVisibleColumns(localVisibleColumns.filter((key) => key !== columnKey));
  };

  const allAvailableColumns = columns
    .filter((col) => !localVisibleColumns.includes(col.key))
    .filter((col) => col.title.toLowerCase().includes(searchText.toLowerCase()));

  const currentlyVisibleColumns = columns.filter((col) => localVisibleColumns.includes(col.key));

  return (
    <div style={{ width: 600 }}>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1, marginRight: 16 }}>
          <h4
            style={{
              color: 'white',
              backgroundColor: '#1890ff',
              padding: '4px 8px',
              borderRadius: 4,
            }}
          >
            Available Columns
          </h4>
          <Input
            placeholder="Search columns"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            size="small"
            style={{ marginBottom: 8 }}
          />
          <div
            style={{ maxHeight: 300, overflowY: 'auto', border: '1px solid #eee', borderRadius: 4 }}
          >
            <List
              dataSource={allAvailableColumns}
              renderItem={(item) => (
                <List.Item
                  actions={[
                    <Button key="add" size="small" onClick={() => addColumn(item)}>
                      +
                    </Button>,
                  ]}
                >
                  {item.title}
                </List.Item>
              )}
            />
          </div>
        </div>
        <div style={{ flex: 1 }}>
          <h4
            style={{
              color: 'white',
              backgroundColor: '#1890ff',
              padding: '4px 8px',
              borderRadius: 4,
            }}
          >
            Order of Selected Columns
          </h4>
          <div
            style={{ maxHeight: 300, overflowY: 'auto', border: '1px solid #eee', borderRadius: 4 }}
          >
            <List
              dataSource={currentlyVisibleColumns}
              renderItem={(item) => (
                <List.Item
                  actions={[
                    <Button key="remove" size="small" onClick={() => removeColumn(item.key)}>
                      x
                    </Button>,
                  ]}
                >
                  {item.title}
                </List.Item>
              )}
            />
          </div>
        </div>
      </div>
      <Divider />
      <div style={{ textAlign: 'right' }}>
        <Button onClick={handleResetToDefault} style={{ marginRight: 8 }}>
          Reset to Default
        </Button>
        <Button type="primary" onClick={handleApplyChanges} style={{ marginRight: 8 }}>
          Update
        </Button>
        <Button onClick={onClose}>Cancel</Button>
      </div>
    </div>
  );
};

export default ColumnVisibileManager;
